import { CorporateModule } from './../corporate/corporate.module';
import { InvestigatorGuard } from './investigator-guard';
import { NgModule } from '@angular/core';
import { DocumentsModule } from '../documents/documents.module';
import { NavigationModule } from '../navigation/navigation.module';
import { SharedModule } from '../shared/shared.module';
import { DocumentsTabsComponent } from './documents-tabs.component';
import { DocumentsWithChildCategoriesComponent } from './documents-with-child-categories.component';
import { DocumentsComponent } from './documents.component';
import { GeneralDocumentsGuard } from './general-documents-guard';
import { LabReportsComponent } from './lab-reports.component';
import { KitInventoryComponent } from './kitinventory/kit-inventory.component';
import { KitInventoryDetailComponent } from './kitinventory/kit-inventory-detail.component';
import { KitInventoryStorage } from './kitinventory/kit-inventory-storage';
import { KitInventoryColumns } from './kitinventory/kit-inventory-columns';
import { InvestigatorNavigationComponent } from './navigation/investigator-navigation.component';
import { SingleCategoryDocumentsGuard } from './single-category-documents-guard';
import { SiteSpecificCategoriesResolver } from './site-specific-categories-resolver';
import { InvestigatorReportsStorage } from './investigator-reports-storage';
import { InvestigatorUnreadReportsStorage } from './investigator-unread-reports-storage';
import { InvestigatorLevelComponent } from './investigator-level.component';
import { InvestigatorMicrobiologyComponent } from './microbiology/investigator-microbiology.component';
import { MicrobiologyDataModule } from '../on-screen-results';
import { SelectedSubjectLabResultsStorage } from './subjects/selected-subject-lab-results-storage';
import { SelectedSubjectResolver } from './subjects/selected-subject-resolver';
import { SubjectsListResolver } from './subjects/subjects-list-resolver';
import { SubjectsRootComponent } from './subjects/subjects-root.component';
import { SubjectsModule } from '../subjects/subjects.module';
import { SubjectsNavigationComponent } from './subjects/subjects-navigation.component';
import { ReactiveFormsModule } from '@angular/forms';
import { InvestigatorEQueriesCountersStorage } from './e-queries/investigator-e-queries-counters-storage';
import { InvestigatorEQueriesStorage } from './e-queries/investigator-e-queries-storage';
import { ExternalUserFilterUrlParamsPreparer } from '../e-queries/external-user-filter-url-params-preparer';
import { EQueriesModule } from '../e-queries/e-queries.module';
import { GlobalPopupModule } from '../global-popup';
import { InvestigatorEQueryModule } from './e-queries/investigator-e-query/investigator-e-query.module';

@NgModule({
    declarations: [
        InvestigatorNavigationComponent,
        DocumentsComponent,
        LabReportsComponent,
        KitInventoryComponent,
        KitInventoryDetailComponent,
        DocumentsTabsComponent,
        DocumentsWithChildCategoriesComponent,
        InvestigatorLevelComponent,
        InvestigatorMicrobiologyComponent,
        SubjectsRootComponent,
        SubjectsNavigationComponent,
    ],
    imports: [
        SharedModule,
        ReactiveFormsModule,
        DocumentsModule,
        NavigationModule,
        MicrobiologyDataModule,
        CorporateModule,
        SubjectsModule,
        EQueriesModule,
        InvestigatorEQueryModule,
        GlobalPopupModule,
    ],
    providers: [
        InvestigatorReportsStorage,
        SiteSpecificCategoriesResolver,
        SingleCategoryDocumentsGuard,
        GeneralDocumentsGuard,
        InvestigatorUnreadReportsStorage,
        InvestigatorGuard,
        SelectedSubjectLabResultsStorage,
        SelectedSubjectResolver,
        SubjectsListResolver,
        KitInventoryStorage,
        KitInventoryColumns,
        InvestigatorEQueriesCountersStorage,
        ExternalUserFilterUrlParamsPreparer,
        InvestigatorEQueriesStorage
    ],
    entryComponents: [
        KitInventoryDetailComponent
    ],
})
export class InvestigatorModule { }
